import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import styles from './Stories.module.css';

const Stories = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.stories}>
      <div className={styles.content}>
        <span className={styles.label}>{t('stories.pageTitle')}</span>
        <h1 className={styles.comingSoon}>{t('stories.pageComingSoon')}</h1>
        <p className={styles.subtitle}>{t('stories.pageSubtitle')}</p>
        <p className={styles.description}>{t('stories.pageDescription')}</p>
      </div>
    </div>
  );
};

export default Stories;
